/* Load-more / infinite scroll.
   Differences from the original:
   - one IntersectionObserver at a time (old ones are disconnected)
   - only one page request at a time (no duplicate/double-appended pages)
   - requests are abortable: facets.js calls window.cancelLoadMore() on every filter change,
     so a page fetched for the OLD filters can never be appended to the NEW results
   - page counter only advances after a page actually loaded (no skipped pages on error)
*/
let loadMoreController = null;
let loadMoreObserver = null;
let loadMoreBusy = false;

function cancelLoadMore() {
  if (loadMoreController) {
    loadMoreController.abort();
    loadMoreController = null;
  }
  if (loadMoreObserver) {
    loadMoreObserver.disconnect();
    loadMoreObserver = null;
  }
  loadMoreBusy = false;
}
window.cancelLoadMore = cancelLoadMore;

function loadItems(trigger) {
  if (loadMoreBusy) return;

  const nextUrlEl = document.querySelector('[data-next-url]');
  const totalEl = document.querySelector('[data-total-pages]');
  const currentEl = document.querySelector('[data-current-page]');
  const grid = document.querySelector('.load-more-grid');
  if (!nextUrlEl || !totalEl || !currentEl || !grid) return;

  const totalPages = parseInt(totalEl.value, 10);
  const nextPage = parseInt(currentEl.value, 10) + 1;
  if (nextPage > totalPages) {
    trigger.remove();
    return;
  }

  const url = nextUrlEl.value.replace(/page=[0-9]+/, 'page=' + nextPage);

  loadMoreBusy = true;
  const controller = new AbortController();
  loadMoreController = controller;
  trigger.setAttribute('disabled', '');
  trigger.classList.add('loading');

  fetch(url, { signal: controller.signal })
    .then((res) => {
      if (!res.ok) throw new Error('Network response was not ok');
      return res.text();
    })
    .then((html) => {
      if (controller.signal.aborted) return;
      const incoming = new DOMParser().parseFromString(html, 'text/html').querySelector('.load-more-grid');
      if (!incoming) return;
      grid.insertAdjacentHTML('beforeend', incoming.innerHTML);
      if (typeof colorSwatches === 'function') colorSwatches();

      // commit progress only after success
      currentEl.value = nextPage;
      currentEl.dataset.currentPage = nextPage;
      const newNext = nextUrlEl.value.replace(/page=[0-9]+/, 'page=' + (nextPage + 1));
      nextUrlEl.value = newNext;
      nextUrlEl.dataset.nextUrl = newNext;

      if (nextPage >= totalPages) {
        trigger.remove();
      }
    })
    .catch((err) => {
      if (err.name !== 'AbortError') console.error('Error loading items:', err);
    })
    .finally(() => {
      if (loadMoreController === controller) loadMoreController = null;
      if (controller.signal.aborted) return; // cancelLoadMore already reset the state
      loadMoreBusy = false;
      trigger.removeAttribute('disabled');
      trigger.classList.remove('loading');
      // if the sentinel is still on screen, re-observing fires again and loads the next page
      if (trigger.isConnected) observeInfiniteScroll();
    });
}

function observeInfiniteScroll() {
  if (loadMoreObserver) loadMoreObserver.disconnect();
  const sentinels = document.querySelectorAll('.js-infinite-scroll');
  if (!sentinels.length) {
    loadMoreObserver = null;
    return;
  }
  loadMoreObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        loadMoreObserver.unobserve(entry.target);
        loadItems(entry.target);
      }
    });
  });
  sentinels.forEach((el) => loadMoreObserver.observe(el));
}

function loadMore() {
  cancelLoadMore();
  document.querySelectorAll('.js-load-more').forEach((btn) => {
    btn.onclick = () => loadItems(btn);
  });
  observeInfiniteScroll();
}

loadMore();